import React from 'react';

export const Branch = () => (
  <svg width="218px" height="154px" viewBox="0 0 218 154" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1026.000000, -509.000000)">
        <g transform="translate(1027.000000, 509.000000)">
          <path
            d="M153.569827,153.828286 L57.4303682,153.828286 L5.50857005,101.847549 C4.83047665,101.168692 4.83047665,100.057914 5.50857005,99.3790569 L104.267034,0.508488428 C104.945999,-0.169496143 106.054655,-0.169496143 106.732749,0.508488428 L205.492084,99.3790569 C206.169305,100.057914 206.169305,101.168692 205.492084,101.847549 L153.569827,153.828286 Z"
            fill="#F3F4F6"
            fillRule="nonzero"
          />
          <polygon
            fill="#F3F4F6"
            points="139.849 153.038 152.689 153.038 152.689 112.003 139.849 112.003"
          />
          <polygon
            fill="#F3F4F6"
            points="152.689 153.038 166.462 153.038 166.462 98.12 152.689 98.12"
          />
          <polygon
            fill="#F3F4F6"
            points="154.983 153.038 183.369 153.038 183.369 84.892 154.983 84.892"
          />
          <polygon
            fill="#F3F4F6"
            points="175.659 153.038 194.261 153.038 194.261 101.318 175.659 101.318"
          />
          <polygon
            fill="#F3F4F6"
            points="193.317 153.038 208.317 153.038 208.317 84.892 193.317 84.892"
          />
          <polygon
            fill="#F3F4F6"
            points="195.918 93.924 205.929 93.924 205.929 79.492 195.918 79.492"
          />
          <polygon
            fill="#F3F4F6"
            points="198.621 84.892 202.681 84.892 202.681 69.234 198.621 69.234"
          />
          <polygon
            fill="#F3F4F6"
            points="122.978 153.038 144.602 153.038 144.602 93.925 122.978 93.925"
          />
          <polygon
            fill="#F3F4F6"
            points="88.267 153.038 128.921 153.038 128.921 113.592 88.267 113.592"
          />
          <polygon
            fill="#F3F4F6"
            points="52.768 153.038 93.422 153.038 93.422 91.634 52.768 91.634"
          />
          <polygon
            fill="#F3F4F6"
            points="59.8609 153.0375 40.7949 153.0375 40.7949 130.6935 59.8609 125.1215"
          />
          <polygon
            fill="#FFFFFF"
            points="42.975 153.185 167.778 153.185 167.778 91.313 42.975 91.313"
          />
          <polygon
            fill="#E8E8E8"
            points="42.976 108.623 167.373 108.623 167.373 91.312 42.976 91.312"
          />
          <path d="M54.98,108.184 L185.505,108.184" fill="#E8E8E8" />
          <polygon
            fill="#E8E8E8"
            points="42.976 97.604 167.373 97.604 167.373 91.313 42.976 91.313"
          />
          <polyline
            stroke="#7462E0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="42.9752 153.185 42.9752 91.313 167.3722 91.313 167.3722 140.183"
          />
          <polygon
            fill="#360823"
            points="44.927 95.172 171.404 95.172 171.404 89.022 44.927 89.022"
          />
          <polygon
            fill="#ED1B2E"
            points="38.094 153.185 77.631 153.185 77.631 69.126 38.094 69.126"
          />
          <polygon
            fill="#64030B"
            points="38.0943 69.1264 38.0943 74.9164 77.6313 71.5134 77.6313 69.1264"
          />
          <polyline
            stroke="#7462E0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="38.0943 153.185 38.0943 69.126 77.6313 69.126 77.6313 117.016"
          />
          <path
            d="M77.6314,123.3754 L77.6314,153.1854"
            stroke="#7462E0"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40.4444,146.1879 L75.5904,146.1879"
            stroke="#FFFFFF"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M51.8892,91.2231 C51.2502,90.2121 51.1102,88.8691 51.1102,87.8361 C51.1102,84.3251 54.2612,81.3611 57.5422,81.3611 L67.8282,81.3611 L63.8362,85.3701 L57.4732,85.3701 C54.9152,85.3701 51.8192,87.9541 51.8892,91.2231 Z M55.8112,88.3491 C56.0762,87.5041 56.9022,86.4231 57.6822,85.8561 C56.1932,85.8561 54.5172,86.5621 53.2392,88.3491 L55.8112,88.3491 Z M57.8692,86.3541 C57.2852,86.8681 56.6462,87.6431 56.3192,88.3491 L59.4072,88.3491 C59.0792,87.6431 58.4392,86.8681 57.8692,86.3541 Z M52.9812,88.8691 C52.5992,89.5541 52.4102,90.3301 52.3422,91.1061 L55.2272,91.1061 C55.2272,90.3301 55.3672,89.5541 55.6242,88.8691 L52.9812,88.8691 Z M56.1232,88.8691 C55.8662,89.5541 55.7482,90.3301 55.6792,91.1061 L60.0462,91.1061 C59.9762,90.3301 59.8582,89.5541 59.6002,88.8691 L56.1232,88.8691 Z M62.4322,88.3491 C61.2072,86.5621 59.5322,85.8561 58.0652,85.8561 C58.8222,86.4241 59.6002,87.5041 59.9282,88.3491 L62.4322,88.3491 Z M60.1162,88.8691 C60.3802,89.5541 60.4972,90.3301 60.4972,91.1061 L63.3842,91.1061 C63.3362,90.3301 63.1412,89.5541 62.7442,88.8691 L60.1162,88.8691 Z M53.2382,94.2371 C54.5172,96.0991 56.1922,96.7371 57.6812,96.7371 C56.9012,96.1471 56.0752,95.0681 55.8102,94.2371 L53.2382,94.2371 Z M57.8692,96.2861 C58.4392,95.7741 59.0792,94.9441 59.4062,94.2371 L56.3182,94.2371 C56.6452,94.9441 57.2852,95.7741 57.8692,96.2861 Z M55.6232,93.7931 C55.3672,93.0181 55.2272,92.2561 55.2272,91.5561 L52.3412,91.5561 C52.4102,92.3111 52.5982,93.0871 52.9802,93.7931 L55.6242,93.7931 L55.6232,93.7931 Z M59.6002,93.7931 C59.8582,93.0871 59.9752,92.3111 60.0452,91.5561 L55.6782,91.5561 C55.7482,92.3111 55.8662,93.0871 56.1232,93.7931 L59.6002,93.7931 Z M59.9282,94.2371 C59.6002,95.0681 58.8222,96.1471 58.0642,96.7371 C59.5312,96.7371 61.2072,96.0991 62.4312,94.2371 L59.9282,94.2371 Z M62.7442,93.7931 C63.1412,93.0871 63.3362,92.3111 63.3842,91.5561 L60.4972,91.5561 C60.4972,92.2561 60.3802,93.0181 60.1162,93.7931 L62.7442,93.7931 Z M63.8352,91.2931 C63.9052,94.6871 60.8252,97.2491 58.2512,97.2491 L51.8892,97.2491 L47.8972,101.2101 L58.1812,101.2101 C61.4652,101.2101 64.6152,98.2681 64.6152,94.7561 C64.6152,93.7241 64.4902,92.3811 63.8362,91.3631 L63.8362,91.2931 L63.8352,91.2931 Z"
            fill="#FFFFFF"
          />
          <polygon
            fill="#360823"
            points="36.467 71.513 79.909 71.513 79.909 66.652 36.467 66.652"
          />
          <g transform="translate(98.000000, 107.710000)">
            <path d="M0.587,0.9135 L0.587,45.2205" />
            <path
              d="M0.587,0.9135 L0.587,45.2205"
              stroke="#D3D3D3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(121.000000, 107.710000)">
            <path d="M0.2584,0.9135 L0.2584,45.2205" fill="#ED0822" />
            <path
              d="M0.2584,0.9135 L0.2584,45.2205"
              stroke="#D3D3D3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(143.000000, 107.710000)">
            <path d="M0.9297,0.9135 L0.9297,45.2205" fill="#ED0822" />
            <path
              d="M0.9297,0.9135 L0.9297,45.2205"
              stroke="#D3D3D3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <polygon
            fill="#360823"
            points="117.003 135.093 118.305 135.093 118.305 130.678 117.003 130.678"
          />
          <polygon
            fill="#360823"
            points="124.436 135.093 125.738 135.093 125.738 130.678 124.436 130.678"
          />
          <polygon
            fill="#E8E8E8"
            points="95.8824 153.6449 79.5834 153.6449 94.4654 108.6239 110.7644 108.6239"
          />
          <polygon
            fill="#E8E8E8"
            points="132.2764 153.6449 115.9774 153.6449 130.8594 108.6239 147.1584 108.6239"
          />
          <polygon
            fill="#FFFFFF"
            points="104.799 104.794 149.917 104.794 149.917 99.968 104.799 99.968"
          />
          <polyline
            stroke="#7462E0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="137.1876 104.7944 104.7986 104.7944 104.7986 99.9684 149.9166 99.9684 149.9166 104.7944 142.8696 104.7944"
          />
          <path
            d="M215.7769,122.6694 C215.7769,119.2744 213.7379,116.3574 210.8149,115.0574 C211.3319,114.0904 211.6249,112.9864 211.6249,111.8154 C211.6249,107.9974 208.5179,104.9024 204.6839,104.9024 C202.0989,104.9024 199.8449,106.3114 198.6509,108.3994 C194.1799,108.5694 190.6079,112.2314 190.6079,116.7264 C190.6079,117.8254 190.8239,118.8754 191.2129,119.8374 C188.8809,122.0554 187.4289,125.1814 187.4289,128.6464 C187.4289,135.3714 192.9039,140.8234 199.6569,140.8234 C206.0389,140.8234 211.2779,135.9534 211.8349,129.7414 C214.2019,128.2694 215.7769,125.6524 215.7769,122.6694"
            fill="#FFFFFF"
          />
          <path
            d="M211.0796,109.1244 C210.0256,106.6434 207.5586,104.9024 204.6836,104.9024 C202.0986,104.9024 199.8456,106.3114 198.6506,108.3994 C194.1806,108.5694 190.6076,112.2304 190.6076,116.7264 C190.6076,117.8254 190.8236,118.8754 191.2126,119.8374 C188.8816,122.0554 187.4296,125.1814 187.4296,128.6454 C187.4296,135.3714 192.9036,140.8234 199.6566,140.8234 C206.0386,140.8234 211.2786,135.9534 211.8346,129.7414 C214.2016,128.2694 215.7766,125.6524 215.7766,122.6694 C215.7766,119.2744 213.7386,116.3564 210.8146,115.0574"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M199.3955,130.7865 C199.3955,130.7865 205.8955,127.1065 206.4015,121.8935"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M199.3955,153.2934 L199.3955,125.2534"
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M182.8599,153.0375 C182.7939,150.3825 180.7179,148.1565 178.0019,147.9515 C177.1279,147.8855 176.2879,148.0375 175.5349,148.3595 C174.3599,145.1675 171.4029,142.7845 167.7779,142.5105 C163.2659,142.1685 159.2809,145.2085 158.3289,149.4835 C158.2979,149.4805 158.2669,149.4745 158.2359,149.4725 C156.1719,149.3155 154.3719,150.8555 154.2159,152.9115 C154.2119,152.9535 154.2139,152.9955 154.2119,153.0375 L182.8599,153.0375 Z"
            fill="#CCD82B"
          />
          <path
            d="M157.6499,153.0375 L182.8599,153.0375 C182.7939,150.3825 180.7179,148.1565 178.0019,147.9515 C177.1279,147.8855 176.2879,148.0375 175.5349,148.3595"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M167.7778,142.5102 C163.2658,142.1682 159.2808,145.2082 158.3288,149.4842 C158.2978,149.4812 158.2668,149.4752 158.2358,149.4722 C156.1718,149.3162 154.3718,150.8562 154.2158,152.9112 C154.2118,152.9532 154.2138,152.9952 154.2118,153.0372"
            stroke="#575700"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="154.983 84.892 183.369 84.892 183.369 101.318 193.317 101.318 193.317 84.892 195.918 84.892 195.918 79.493 198.621 79.493 198.621 69.234 202.681 69.234 202.681 79.493 205.929 79.493 205.929 84.892 208.317 84.892 208.317 98.12"
          />
          <path
            d="M11.0992,153.3178 L0.0632,153.3178"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M152.6885,153.3178 L38.0995,153.3178"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M181.6499,116.3334 L181.6499,117.6484"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M181.6499,120.2797 L181.6499,121.5957"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M184.2813,118.9643 L182.9663,118.9643"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M180.3345,118.9643 L179.0185,118.9643"
            stroke="#F2C217"
            strokeLinecap="round"
          />
          <path
            d="M166.7871,77.0629 C166.7871,77.5449 166.3951,77.9369 165.9131,77.9369 C165.4301,77.9369 165.0391,77.5449 165.0391,77.0629 C165.0391,76.5799 165.4301,76.1889 165.9131,76.1889 C166.3951,76.1889 166.7871,76.5799 166.7871,77.0629"
            fill="#D62793"
          />
          <path
            d="M119.1793,74.9164 C119.1793,75.3984 118.7883,75.7904 118.3053,75.7904 C117.8233,75.7904 117.4313,75.3984 117.4313,74.9164 C117.4313,74.4344 117.8233,74.0424 118.3053,74.0424 C118.7883,74.0424 119.1793,74.4344 119.1793,74.9164"
            fill="#CCD82B"
          />
          <path
            d="M135.6573,65.7953 L135.6573,67.5453"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M135.6573,71.0453 L135.6573,72.7953"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M139.1573,69.2953 L137.4073,69.2953"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M133.9073,69.2953 L132.1573,69.2953"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
        </g>
      </g>
    </g>
  </svg>
);
